import { useState } from 'react';
import { Link } from 'react-router-dom';
import './ClientCard.css';

function getInitials(name) {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

function getComplianceLevel(rate) {
  if (rate >= 75) return 'good';
  if (rate >= 50) return 'moderate';
  return 'poor';
}

export default function ClientCard({ client, onRemove }) {
  const {
    id,
    name,
    totalItems,
    trackingRate,
    daysSinceStart,
    loggedToday,
  } = client;

  const [confirming, setConfirming] = useState(false);
  const [removing, setRemoving] = useState(false);

  const level = getComplianceLevel(trackingRate);

  const handleRemoveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setConfirming(true);
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setRemoving(true);
    if (onRemove) {
      await onRemove(id, name);
    }
    setRemoving(false);
    setConfirming(false);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setConfirming(false);
  };

  return (
    <div className="client-card-wrapper">
      <Link to={`/practitioner/clients/${id}`} className="client-card">
        <div className="client-card-left">
          <div className={`client-avatar avatar-${level}`}>
            {getInitials(name)}
          </div>
          <div className="client-info">
            <h3 className="client-name">{name}</h3>
            <div className="client-meta">
              <span>{totalItems} item{totalItems !== 1 ? 's' : ''}</span>
              <span className="meta-dot">·</span>
              <span>Day {daysSinceStart}</span>
              {loggedToday && (
                <>
                  <span className="meta-dot">·</span>
                  <span className="logged-badge">Logged today</span>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="client-card-right">
          <div className={`compliance-ring ring-${level}`}>
            <span className="compliance-value">{trackingRate}%</span>
          </div>
        </div>
      </Link>

      {/* Remove button — sits below the card link */}
      {!confirming ? (
        <button
          className="client-remove-btn"
          onClick={handleRemoveClick}
          title="Remove client"
          aria-label={`Remove ${name}`}
        >
          ×
        </button>
      ) : (
        <div className="client-remove-confirm">
          <span className="remove-confirm-text">Remove {name.split(' ')[0]}?</span>
          <button
            className="remove-confirm-yes"
            onClick={handleConfirm}
            disabled={removing}
          >
            {removing ? 'Removing...' : 'Yes, remove'}
          </button>
          <button
            className="remove-confirm-no"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}
